export enum LicenseDurationValidityEnum {
    FiscalYear = 1,
    CalendarYear = 2
}
